module.exports = __webpack_public_path__ + "static/media/6.3e793984.jpg";